export var logout = function (e) {
    if (e.status === 401) {
        localStorage.clear();
        window.location.reload();
    }
};
